import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbSecurityModule } from '@nebular/security';
import { IsAppRolesModule } from '../../../core/utils/app-roles/app-roles.module';
import { MaterialModule } from '../../../shared/material-module';
import { DialogGroupPromptComponent } from './dialog-group-prompt/dialog-group-prompt.component';
import { VersionDetailsComponent } from './version-details/version-details.component';
import { VersionDialogComponent } from './version-dialog.component';
import { VersionComponent } from './version/version.component';
import { VersionsContentComponent } from './versions-content.component';
import { VersionsComponent } from './versions.component';

@NgModule({
  declarations: [
    DialogGroupPromptComponent,
    VersionComponent,
    VersionDialogComponent,
    VersionsContentComponent,
    VersionsComponent,
    VersionDetailsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    IsAppRolesModule,
    NbSecurityModule
  ],
  exports: [VersionsComponent, VersionDetailsComponent]
})
export class VersionsModule {}
